export default __webpack_public_path__ + "static/media/empty-participants-switch.ef8c507e.svg";